import React, { type FunctionComponent } from 'react'
import { spacing, Text, colors } from '@retailer-platform/shared-components'
import styled from '@emotion/styled'
import { css } from '@emotion/react'

interface Props {
  color: string
}

const ColorDisplay = styled.div(
  {
    width: 16,
    height: 16,
    marginRight: spacing.X8,
    borderRadius: 4,
    border: `1px solid ${colors.GRAYSCALE.X10}`,
  },
  props => ({
    backgroundColor: props.color,
  })
)

const Wrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
})

export const CollectionsColorInfo: FunctionComponent<Props> = ({ color }) => (
  <Wrapper>
    <ColorDisplay color={color} />
    <Text styles={css({ marginLeft: 0 })} size="medium">
      {color}
    </Text>
  </Wrapper>
)
